module.exports = __webpack_public_path__ + "img/outer_temp_device.556d8f1e.svg";